import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
    creationDateDescSortInfo,
    SortInfo
} from '../../../overviews/generic-overview/components/display-settings-bar/entities/sort-info.entity';
import { CustomHttpParamEncoder } from '../../http/entities/custom-http-param-encoder';
import { ShPaginationService } from '../../http/services/pagination.service';
import { ApiJob } from '../../jobs/entities/api-job.entity';
import { Identifier } from '../entities/metadata/metadata.entity';

@Injectable({ providedIn: 'root' })
export class RecordJobsDataService {
    private readonly paginationService: ShPaginationService = inject(ShPaginationService);

    private getEndpoint(recordId: string) {
        return `v2/records/${recordId}/jobs`;
    }

    getRecordJobs(recordId: Identifier, sortInfo: SortInfo = creationDateDescSortInfo): Observable<ApiJob[]> {
        const params: HttpParams = new HttpParams({ encoder: new CustomHttpParamEncoder() })
            .set('SortField', sortInfo.field)
            .set('SortDirection', sortInfo.direction);

        const endpoint: string = this.getEndpoint(recordId);

        return this.paginationService.getAll(endpoint, params);
    }
}
